import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { platformIsMobile } from '../util';
const PADDING_NONE = ['0px', '0%', '0em'];
let Page = class Page extends Vue {
  get extraStyles() {
    let styles = {};
    const isMobile = platformIsMobile();
    if (isMobile) {
      if (this.mobilePadding && !PADDING_NONE.includes(this.mobilePadding)) styles.padding = this.mobilePadding;
    } else {
      if (this.padding && !PADDING_NONE.includes(this.padding)) styles.padding = this.padding;
      if (this.width) {
        styles.width = this.width;
        styles.margin = 'auto';
      }
    }
    return styles;
  }
};
Page.componentName = 'Page';
__decorate([Prop(String)], Page.prototype, "width", void 0);
__decorate([Prop({
  default: '16px'
})], Page.prototype, "padding", void 0);
__decorate([Prop(String)], Page.prototype, "mobilePadding", void 0);
Page = __decorate([Component({
  name: 'Page'
})], Page);
export default Page;